import { z } from 'zod';

/**
 * Satın alma ve stok raporları (ADR 0040 #189; `satin-alma-akisi.jpeg` "Reports"). Ofis ve gemi
 * aynı süzgeçleri kullanır; gün aralığı gemi yerel günüdür, varsayılan son 30 gün.
 */
export const REPORTS = ['requisitions', 'orders', 'stock', 'consumption'] as const;
export type ReportKind = (typeof REPORTS)[number];

/** Raporun görme yetkisi: talep ve sipariş satın almanın, stok ve tüketim stoğun modülü. */
export const REPORT_MODULE: Readonly<Record<ReportKind, 'purchasing' | 'stock'>> = {
  requisitions: 'purchasing',
  orders: 'purchasing',
  stock: 'stock',
  consumption: 'stock',
};

/** Varsayılan aralığın gün sayısı. */
export const DEFAULT_REPORT_DAYS = 30;

export const reportQuerySchema = z
  .strictObject({
    vessel: z.uuid().optional(),
    from: z.iso.date().optional(),
    to: z.iso.date().optional(),
    status: z
      .string()
      .regex(/^[a-z_]{1,40}$/)
      .optional(),
  })
  .refine((query) => !query.from || !query.to || query.from <= query.to, { path: ['to'] });
export type ReportQuery = z.output<typeof reportQuerySchema>;

/** Süzgeçteki aralık; verilmeyen uçlar bugün ve 30 gün öncesi. */
export function reportRange(query: ReportQuery, today: string): { from: string; to: string } {
  const to = query.to ?? today;
  if (query.from) return { from: query.from, to };
  const date = new Date(`${to}T00:00:00Z`);
  date.setUTCDate(date.getUTCDate() - DEFAULT_REPORT_DAYS);
  return { from: date.toISOString().slice(0, 10), to };
}
